import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, defineAsyncComponent } from "vue";
import { useHomeStore } from "@/stores/home";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const Worker = defineAsyncComponent(() => import("./partial/countries.vue"));
const Service = defineAsyncComponent(() => import("./partial/service.vue"));
const Inquiries = defineAsyncComponent(() => import("./partial/inquiries.vue"));
const About = defineAsyncComponent(() => import("./partial/about.vue"));
const Hero = defineAsyncComponent(() => import("./partial/hero.vue"));
const Banner = defineAsyncComponent(() => import("./partial/banner.vue"));

const homeStore = useHomeStore();
onMounted(() => {
  homeStore.getHome();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Hero)),
    _createVNode(_unref(About)),
    _createVNode(_unref(Service)),
    _createVNode(_unref(Worker)),
    _createVNode(_unref(Banner)),
    _createVNode(_unref(Inquiries))
  ], 64))
}
}

})